import { computed } from 'vue';
import { useMediaQuery } from '@vueuse/core';
import { cameraControls, cameraRail } from '@carvia/theme/lib/cva/camera-button';
import { useScreenOrientationAngle } from '@/hooks/use-screen-orientation-angle';

/** Rail and control layout of the full-screen damage cameras, following the screen rotation. */
export function useCameraLayout() {
  const isLandscape = useMediaQuery('(orientation: landscape)');
  const orientationAngle = useScreenOrientationAngle();

  const railClass = computed(() =>
    cameraRail({ orientation: isLandscape.value ? 'landscape' : 'portrait' }),
  );
  const controlsClass = computed(() => {
    if (!isLandscape.value) return cameraControls({ layout: 'row' });
    const angle = ((orientationAngle.value % 360) + 360) % 360;
    return cameraControls({ layout: angle === 90 ? 'columnReversed' : 'column' });
  });

  return { isLandscape, orientationAngle, railClass, controlsClass };
}
